import React from "react";
import { map, includes } from "lodash";

import TextInput from "components/shared/form/fields/TextInput";
import Select from "components/shared/form/fields/Select";
import RadioButton from "components/shared/form/fields/RadioButton";

const AVAILABLE_LANGUAGES = ["de", "de_DU", "en", "es", "fr"];

function BasicSettings() {
  return (
    <>
      <h3>
        {I18n.t("js.administration.network_settings.basic_settings.title")}
      </h3>
      <div className="form-horizontal">
        <TextInput
          name="name"
          label={I18n.t("js.administration.network_settings.name_label")}
          required
        />
        <Select
          name="language"
          label={I18n.t("js.administration.network_settings.language_label")}
          options={
            includes(AVAILABLE_LANGUAGES, Preload.current_network.language)
              ? map(AVAILABLE_LANGUAGES, (lang) => ({
                  value: lang,
                  label: I18n.t(`js.networks.languages.${lang}`),
                }))
              : [
                  {
                    value: Preload.current_network.language || "",
                    label: I18n.t(
                      `js.networks.languages.${Preload.current_network.language}`,
                    ),
                  },
                ]
          }
          disabled={
            !includes(AVAILABLE_LANGUAGES, Preload.current_network.language)
          }
        />
        {Preload.current_network.config.abuse_reports.admin_configurable && (
          <RadioButton
            label={I18n.t(
              "js.administration.network_settings.abuse_reporting.label",
            )}
            name="abuse_reports_enabled"
            options={[
              {
                value: "enabled",
                label: I18n.t(
                  "js.administration.network_settings.abuse_reporting.enabled",
                ),
              },
              {
                value: "disabled",
                label: I18n.t(
                  "js.administration.network_settings.abuse_reporting.disabled",
                ),
              },
            ]}
          />
        )}
      </div>
    </>
  );
}

export default BasicSettings;
